import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome';
import BrandEditor from '../../../components/BrandEditor'
import BrandLogisticsEditor from '../../../components/BrandLogisticsEditor';
import ProductEditor from '../../../components/ProductEditor';
import ProductList from '../../../components/ProductList';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Api from '../../../Api';

import './style.less';

export default class AdminBrandEdit extends Component {
  constructor(props) {
    super(props);

    this.brandUpdated = this.brandUpdated.bind(this);
    this.onNewProduct = this.onNewProduct.bind(this);
    this.onSelectIndex = this.onSelectIndex.bind(this);
    this.onProductUpdated = this.onProductUpdated.bind(this);

    this.state = {
      brand: Api.cache.getBrand(props.params.brandToken),
      products: []
    };
  }

  componentWillMount() {
    Api.cache.addChangeListener(this.brandUpdated, Api.cache.eventTypes.BRANDS_CHANGED);
  }

  componentDidMount() {
    Api.getBrand(this.props.params.brandToken, true);

    Api.getBrandProducts(this.props.params.brandToken).then(
      (response) => {
        let products = response;
        if (!products || products.length === 0) {
          this.onNewProduct();
        } else {
          this.setState({
            products,
            selectedIndex: 0,
          });
        }
      }
    );
  }

  componentWillUnmount() {
    Api.cache.removeChangeListener(this.brandUpdated, Api.cache.eventTypes.BRANDS_CHANGED);
  }

  brandUpdated() {
    this.setState({
      brand: Api.cache.getBrand(this.props.params.brandToken)
    });
  }

  onNewProduct() {
    let products = this.state.products || [];
    products.push({
      name: `Product ${products.length}`,
      active: true,
      short_description: null,
      description: null,
      wholesale_price_cents: null,
      retail_price_cents: null,
      unit_multiplier: null,
      categories: [],
      images: []
    });

    let selectedIndex = products.length - 1;

    this.setState({
      products,
      selectedIndex
    });
  }

  onSelectIndex(index) {
    this.setState({
      selectedIndex: index
    });
  }

  onProductUpdated(product) {
    let products = this.state.products;
    products[this.state.selectedIndex] = product;
    this.setState({
      products
    });
  }

  render() {
    if (!this.state.brand) {
      return <div><FontAwesome name="circle-o-notch" spin /></div>;
    }

    let productView = <div><FontAwesome name="circle-o-notch" spin /></div>;
    if (this.state.products) {
      let products = this.state.products;
      let selectedProduct = products[this.state.selectedIndex];
      let selectedKey = (selectedProduct && selectedProduct.token) || `new-product-key-${this.state.selectedIndex}`;
      productView = (
          <div className="admin-brand-edit-products-container">
            <ProductList onNew={this.onNewProduct}
                         onSelect={this.onSelectIndex}
                         selectedIndex={this.state.selectedIndex}
                         products={products}
                         keyName="name" />
            <ProductEditor product={selectedProduct}
                           brandToken={this.props.params.brandToken}
                           brandName={(this.state.brand && this.state.brand.name) || null}
                           onUpdated={this.onProductUpdated}
                           updateOnKey="name"
                           key={selectedKey} />
          </div>);
    }
    return (
      <div className="admin-brand-edit-component">
        <h2>{this.state.brand.name}</h2>
        <Tabs>
          <TabList>
            <Tab>Edit Brand</Tab>
            <Tab>Edit Products</Tab>
            <Tab>Edit Advanced</Tab>
          </TabList>
          <TabPanel>
            <BrandEditor brand={this.state.brand} />
          </TabPanel>
          <TabPanel>
            {productView}
          </TabPanel>
          <TabPanel>
            <BrandLogisticsEditor logistics={this.state.brand} />
          </TabPanel>
        </Tabs>
      </div>
    );
  }
}




/** WEBPACK FOOTER **
 ** ./src/views/admin/AdminBrandEdit/index.js
 **/